interface ActionButtonCellProps {
  text: string;
  onClick?: (e: React.MouseEvent) => void;
}

export function TextButtonCell({ text, onClick }: ActionButtonCellProps) {
  return (
    <td className="size-px whitespace-nowrap px-4 py-1">
      <button
        type="button"
        className="text-sm text-primary hover:text-primary-darker hover:underline"
        onClick={onClick}
      >
        {text}
      </button>
    </td>
  );
}
